import axios from '@/utils/ajax';
import {isDev} from '@/utils/environment';

/**
 * ufo 平台接口
 * 链接：https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/wVIHAgRKmU/6bsm-DaS7-/-5R8YK2D74firI
 */
export const ufoUrl = `${isDev ? 'http' : 'https'}://ufosdk.baidu.com`;

const commonParams = {
    m: 'Api'
};
const appid = 245828;

/**
 * 提交反馈
 * screenshot 图片：接收上传图片的base64编码或者图片url多图以数组形式post提交
 * 上限：4张 如需开放联系UFO PM进行调整
 */
export const postFeedback = (content, screenshot) => {
    // 把数组转成 screenshot[]=url1&screenshot[]=url2 这种格式
    const data = {
        appid,
        content
    };
    screenshot.forEach((url, i) => {
        data[`screenshot[${i}]`] = url;
    });

    return axios({
        method: 'post',
        url: ufoUrl,
        params: {
            a: 'postMsg',
            ...commonParams
        },
        data: data
    });
};